import { use } from 'react';
import { CarouselContext, CarouselDispatchContext } from './CarouselContext';

export const useCarousel = () => use(CarouselContext);
export const useCarouselDispatch = () => use(CarouselDispatchContext);
